import React, { useState } from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import restaurantImg from "../assets/restorent/restaurant.png";

/* ─── Schemas ───────────────────────────────────────────────────── */
const salemFAQSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "What makes Barbequeen the best restaurant in Salem?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Since 1999, we've paired real charcoal-grill expertise with consistent quality and generous portions, from double-marinated grill chicken to biryani and mandi.",
      },
    },
    {
      "@type": "Question",
      name: "Where can I find the best barbecue in Salem?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "At Barbequeen, home of the Double Marinated Grill Chicken, marinated twice and charcoal-grilled till smoky and tender, alongside our kababs and tandoori specials.",
      },
    },
    {
      "@type": "Question",
      name: "Which is the best biryani in Salem?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "We layer aged basmati with marinated chicken or slow-cooked mutton over a gentle dum. Fluffy rice, tender meat, and balanced spice.",
      },
    },
    {
      "@type": "Question",
      name: "How many outlets are there, and what are the timings?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "We run eight outlets across Salem, from Five Roads to Modern Theatre. All are open daily, 11:00 AM to 11:00 PM, for dine-in, takeaway, and delivery.",
      },
    },
    {
      "@type": "Question",
      name: "Does Barbequeen offer delivery and vegetarian options?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Yes. Doorstep delivery plus online ordering via Swiggy and Zomato. Our menu also has a full veg spread, from paneer butter masala to starters and desserts.",
      },
    },
  ],
};

const salemRestaurantSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://barbequeen.com/#organization",
      name: "Barbequeen Restaurant",
      legalName: "Nonvee Foods Private Limited",
      url: "https://barbequeen.com/",
      logo: {
        "@type": "ImageObject",
        url: "https://barbequeen.com/images/logo.png",
      },
      foundingDate: "1999",
      sameAs: [
        "https://facebook.com/BarbequeenRestaurant/",
        "https://instagram.com/barbequeenrestaurant/",
      ],
    },
    {
      "@type": "Restaurant",
      "@id": "https://barbequeen.com/best-restaurant-in-salem#five-roads",
      name: "Barbequeen - Five Roads (Junction)",
      image: "https://barbequeen.com/images/barbequeen.jpg",
      url: "https://barbequeen.com/best-restaurant-in-salem",
      telephone: "+919659184555",
      priceRange: "₹₹",
      servesCuisine: [
        "Barbecue",
        "Grill",
        "Tandoori",
        "Arabian",
        "North Indian",
        "Biryani",
        "Chinese",
      ],
      parentOrganization: { "@id": "https://barbequeen.com/#organization" },
      address: {
        "@type": "PostalAddress",
        streetAddress: "Reliance Mall, Junction Main Rd",
        addressLocality: "Salem",
        addressRegion: "Tamil Nadu",
        postalCode: "636004",
        addressCountry: "IN",
      },
      openingHoursSpecification: {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ],
        opens: "11:00",
        closes: "23:00",
      },
    },
    {
      "@type": "Restaurant",
      "@id": "https://barbequeen.com/best-restaurant-in-salem#sona",
      name: "Barbequeen - Sona",
      image: "https://barbequeen.com/images/barbequeen.jpg",
      url: "https://barbequeen.com/best-restaurant-in-salem",
      telephone: "+919659174555",
      priceRange: "₹₹",
      servesCuisine: [
        "Barbecue",
        "Grill",
        "Tandoori",
        "Arabian",
        "North Indian",
        "Biryani",
        "Chinese",
      ],
      parentOrganization: { "@id": "https://barbequeen.com/#organization" },
      address: {
        "@type": "PostalAddress",
        streetAddress: "Junction Main Rd, Near Sona College, Subramania Nagar",
        addressLocality: "Salem",
        addressRegion: "Tamil Nadu",
        postalCode: "636005",
        addressCountry: "IN",
      },
      openingHoursSpecification: {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ],
        opens: "11:00",
        closes: "23:00",
      },
    },
    {
      "@type": "Restaurant",
      "@id": "https://barbequeen.com/best-restaurant-in-salem#fairlands",
      name: "Barbequeen - Fairlands",
      image: "https://barbequeen.com/images/barbequeen.jpg",
      url: "https://barbequeen.com/best-restaurant-in-salem",
      telephone: "+919003610005",
      priceRange: "₹₹",
      servesCuisine: [
        "Barbecue",
        "Grill",
        "Tandoori",
        "Arabian",
        "North Indian",
        "Biryani",
        "Chinese",
      ],
      parentOrganization: { "@id": "https://barbequeen.com/#organization" },
      address: {
        "@type": "PostalAddress",
        streetAddress: "31, Greenways Rd, Sinthampalayam, Fairlands",
        addressLocality: "Salem",
        addressRegion: "Tamil Nadu",
        postalCode: "636016",
        addressCountry: "IN",
      },
      openingHoursSpecification: {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ],
        opens: "11:00",
        closes: "23:00",
      },
    },
    {
      "@type": "Restaurant",
      "@id": "https://barbequeen.com/best-restaurant-in-salem#hasthampatty",
      name: "Barbequeen - Hasthampatty",
      image: "https://barbequeen.com/images/barbequeen.jpg",
      url: "https://barbequeen.com/best-restaurant-in-salem",
      telephone: "+919894055651",
      priceRange: "₹₹",
      servesCuisine: [
        "Barbecue",
        "Grill",
        "Tandoori",
        "Arabian",
        "North Indian",
        "Biryani",
        "Chinese",
      ],
      parentOrganization: { "@id": "https://barbequeen.com/#organization" },
      address: {
        "@type": "PostalAddress",
        streetAddress: "No 43, N.C.A.S. Building, Hasthampatti Main Rd",
        addressLocality: "Salem",
        addressRegion: "Tamil Nadu",
        postalCode: "636007",
        addressCountry: "IN",
      },
      openingHoursSpecification: {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ],
        opens: "11:00",
        closes: "23:00",
      },
    },
    {
      "@type": "Restaurant",
      "@id": "https://barbequeen.com/best-restaurant-in-salem#gugai",
      name: "Barbequeen - Gugai",
      image: "https://barbequeen.com/images/barbequeen.jpg",
      url: "https://barbequeen.com/best-restaurant-in-salem",
      telephone: "+919003344900",
      priceRange: "₹₹",
      servesCuisine: [
        "Barbecue",
        "Grill",
        "Tandoori",
        "Arabian",
        "North Indian",
        "Biryani",
        "Chinese",
      ],
      parentOrganization: { "@id": "https://barbequeen.com/#organization" },
      address: {
        "@type": "PostalAddress",
        streetAddress: "No 402, Trichy Main Rd, Sendarapatti, Gugai",
        addressLocality: "Salem",
        addressRegion: "Tamil Nadu",
        postalCode: "636006",
        addressCountry: "IN",
      },
      openingHoursSpecification: {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ],
        opens: "11:00",
        closes: "23:00",
      },
    },
    {
      "@type": "Restaurant",
      "@id": "https://barbequeen.com/best-restaurant-in-salem#cherry-road",
      name: "Barbequeen - Cherry Road",
      image: "https://barbequeen.com/images/barbequeen.jpg",
      url: "https://barbequeen.com/best-restaurant-in-salem",
      telephone: "+919659204555",
      priceRange: "₹₹",
      servesCuisine: [
        "Barbecue",
        "Grill",
        "Tandoori",
        "Arabian",
        "North Indian",
        "Biryani",
        "Chinese",
      ],
      parentOrganization: { "@id": "https://barbequeen.com/#organization" },
      address: {
        "@type": "PostalAddress",
        streetAddress: "223, Cherry Rd, Near Eswaran Temple, Opp. Petrol Pump",
        addressLocality: "Salem",
        addressRegion: "Tamil Nadu",
        postalCode: "636001",
        addressCountry: "IN",
      },
      openingHoursSpecification: {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ],
        opens: "11:00",
        closes: "23:00",
      },
    },
    {
      "@type": "Restaurant",
      "@id":
        "https://barbequeen.com/best-restaurant-in-salem#seelanaickenpatti",
      name: "Barbequeen - Seelanaickenpatti",
      image: "https://barbequeen.com/images/barbequeen.jpg",
      url: "https://barbequeen.com/best-restaurant-in-salem",
      telephone: "+919003320433",
      priceRange: "₹₹",
      servesCuisine: [
        "Barbecue",
        "Grill",
        "Tandoori",
        "Arabian",
        "North Indian",
        "Biryani",
        "Chinese",
      ],
      parentOrganization: { "@id": "https://barbequeen.com/#organization" },
      address: {
        "@type": "PostalAddress",
        streetAddress:
          "Trichy Main Rd, Annamali Nagar, MGR Nagar, Seelanaickenpatti",
        addressLocality: "Salem",
        addressRegion: "Tamil Nadu",
        postalCode: "636201",
        addressCountry: "IN",
      },
      openingHoursSpecification: {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ],
        opens: "11:00",
        closes: "23:00",
      },
    },
    {
      "@type": "Restaurant",
      "@id": "https://barbequeen.com/best-restaurant-in-salem#modern-theatre",
      name: "Barbequeen - Modern Theatre",
      image: "https://barbequeen.com/images/barbequeen.jpg",
      url: "https://barbequeen.com/best-restaurant-in-salem",
      telephone: "+919087222285",
      priceRange: "₹₹",
      servesCuisine: [
        "Barbecue",
        "Grill",
        "Tandoori",
        "Arabian",
        "North Indian",
        "Biryani",
        "Chinese",
      ],
      parentOrganization: { "@id": "https://barbequeen.com/#organization" },
      address: {
        "@type": "PostalAddress",
        streetAddress:
          "61, Yercaud Main Rd, Near Modern Theatre, Chinnakollapatty",
        addressLocality: "Salem",
        addressRegion: "Tamil Nadu",
        postalCode: "636008",
        addressCountry: "IN",
      },
      openingHoursSpecification: {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ],
        opens: "11:00",
        closes: "23:00",
      },
    },
  ],
};

/* ─── Outlets Data ──────────────────────────────────────────────── */
const SALEM_OUTLETS = [
  {
    id: "five-roads",
    name: "Barbequeen - Five Roads (Junction)",
    address: "Reliance Mall, Junction Main Rd, Salem, Tamil Nadu 636004",
    phone: "+91 96591 84555",
    callNumber: "+919659184555",
    mapQuery: "Barbequeen Reliance Mall Junction Main Rd Salem",
  },
  {
    id: "sona",
    name: "Barbequeen - Sona",
    address:
      "Junction Main Rd, Near Sona College, Subramania Nagar, Salem, Tamil Nadu 636005",
    phone: "+91 96591 74555",
    callNumber: "+919659174555",
    mapQuery: "Barbequeen Sona College Junction Main Rd Salem",
  },
  {
    id: "fairlands",
    name: "Barbequeen - Fairlands",
    address:
      "31, Greenways Rd, Sinthampalayam, Fairlands, Salem, Tamil Nadu 636016",
    phone: "+91 90036 10005",
    callNumber: "+919003610005",
    mapQuery: "Barbequeen Fairlands Greenways Rd Salem",
  },
  {
    id: "hasthampatty",
    name: "Barbequeen - Hasthampatty",
    address:
      "No 43, N.C.A.S. Building, Hasthampatti Main Rd, Salem, Tamil Nadu 636007",
    phone: "+91 98940 55651",
    callNumber: "+919894055651",
    mapQuery: "Barbequeen Hasthampatti Main Rd Salem",
  },
  {
    id: "gugai",
    name: "Barbequeen - Gugai",
    address:
      "No 402, Trichy Main Rd, Sendarapatti, Gugai, Salem, Tamil Nadu 636006",
    phone: "+91 90033 44900",
    callNumber: "+919003344900",
    mapQuery: "Barbequeen Trichy Main Rd Gugai Salem",
  },
  {
    id: "cherry-road",
    name: "Barbequeen - Cherry Road",
    address:
      "223, Cherry Rd, Near Eswaran Temple, Opp. Petrol Pump, Salem, Tamil Nadu 636001",
    phone: "+91 96592 04555",
    callNumber: "+919659204555",
    mapQuery: "Barbequeen Cherry Rd Eswaran Temple Salem",
  },
  {
    id: "seelanaickenpatti",
    name: "Barbequeen - Seelanaickenpatti",
    address:
      "Trichy Main Rd, Annamali Nagar, MGR Nagar, Seelanaickenpatti, Salem, Tamil Nadu 636201",
    phone: "+91 90033 20433",
    callNumber: "+919003320433",
    mapQuery: "Barbequeen Seelanaickenpatti Trichy Main Rd Salem",
  },
  {
    id: "modern-theatre",
    name: "Barbequeen - Modern Theatre",
    address:
      "61, Yercaud Main Rd, Near Modern Theatre, Chinnakollapatty, Salem, Tamil Nadu 636008",
    phone: "+91 90872 22285",
    callNumber: "+919087222285",
    mapQuery: "Barbequeen Modern Theatre Yercaud Main Rd Salem",
  },
];

const FAQS = [
  {
    q: "What makes Barbequeen the best restaurant in Salem?",
    a: "Since 1999, we've paired real charcoal-grill expertise with consistent quality and generous portions, from double-marinated grill chicken to biryani and mandi.",
  },
  {
    q: "Where can I find the best barbecue in Salem?",
    a: "At Barbequeen, home of the Double Marinated Grill Chicken, marinated twice and charcoal-grilled till smoky and tender, alongside our kababs and tandoori specials.",
  },
  {
    q: "Which is the best biryani in Salem?",
    a: "We layer aged basmati with marinated chicken or slow-cooked mutton over a gentle dum. Fluffy rice, tender meat, and balanced spice.",
  },
  {
    q: "How many outlets are there, and what are the timings?",
    a: "We run eight outlets across Salem, from Five Roads to Modern Theatre. All are open daily, 11:00 AM to 11:00 PM, for dine-in, takeaway, and delivery.",
  },
  {
    q: "Does Barbequeen offer delivery and vegetarian options?",
    a: "Yes. Doorstep delivery plus online ordering via Swiggy and Zomato. Our menu also has a full veg spread, from paneer butter masala to starters and desserts.",
  },
];

const OTHER_GUIDES = [
  {
    title: "Best Restaurant in Coimbatore",
    path: "/best-restaurant-in-coimbatore",
    city: "Coimbatore",
  },
  {
    title: "Best Restaurant in Erode",
    path: "/best-restaurant-in-erode",
    city: "Erode",
  },
  {
    title: "Best Restaurant in Krishnagiri",
    path: "/best-restaurant-in-krishnagiri",
    city: "Krishnagiri",
  },
  {
    title: "Best Restaurant in Pudukkottai",
    path: "/best-restaurant-in-pudukkottai",
    city: "Pudukkottai",
  },
];

const BestRestaurantInSalemPage = () => {
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (idx) => {
    setOpenFaq(openFaq === idx ? null : idx);
  };

  const pageTitle = "Best Restaurant in Salem | Barbequeen – Grill & Barbecue";
  const pageUrl = "https://barbequeen.com/best-restaurant-in-salem";

  return (
    <div
      className="min-h-screen bg-[#f9f5f0]"
      style={{ fontFamily: "'Inter', 'Segoe UI', sans-serif" }}
    >
      {/* ── SEO & Schemas ── */}
      <SEO
        title={pageTitle}
        metaTitle={pageTitle}
        description="Barbequeen — Salem's best restaurant since 1999. Charcoal grill chicken, biryani & Arabian mandi across 8 outlets. Order online or dine in."
        keywords="Best Restaurant in Salem, Best Barbecue in Salem, Best Biryani in Salem"
        robots="index, follow"
        canonical={pageUrl}
        geo={{
          region: "IN-TN",
          placename: "Salem, Tamil Nadu",
          position: "11.6643;78.1460",
          icbm: "11.6643, 78.1460",
        }}
        og={{
          type: "website",
          url: pageUrl,
          title: pageTitle,
          description:
            "Home of the Double Marinated Grill Chicken. Charcoal barbecue, biryani & Arabian mandi across 8 Salem outlets. Dine-in, takeaway & delivery.",
          image: "https://barbequeen.com/images/barbequeen-og.jpg",
          imageWidth: "1200",
          imageHeight: "630",
          siteName: "Barbequeen Restaurant",
          locale: "en_IN",
        }}
        schema={[salemRestaurantSchema, salemFAQSchema]}
      />

      {/* ── Hero Banner (Blog Style) ── */}
      <section
        className="relative overflow-hidden"
        style={{ minHeight: "360px" }}
      >
        <img
          src="https://images.unsplash.com/photo-1544025162-d76694265947?q=80&w=1600&auto=format&fit=crop"
          alt="Best Restaurant in Salem - Barbequeen"
          className="absolute inset-0 w-full h-full object-cover object-center scale-105"
          onError={(e) => {
            e.target.src = restaurantImg;
          }}
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(to bottom, rgba(10,0,2,0.82) 0%, rgba(10,0,2,0.92) 100%)",
          }}
        />

        <div className="relative z-10 max-w-6xl mx-auto px-4 lg:px-8 pt-28 sm:pt-32 pb-14 text-left">
          {/* Breadcrumbs */}
          <nav className="flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-white/60 mb-5">
            <Link to="/" className="hover:text-white transition-colors">
              Home
            </Link>
            <svg
              className="w-3 h-3 text-white/40"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2.5}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9 5l7 7-7 7"
              />
            </svg>
            <Link to="/blog" className="hover:text-white transition-colors">
              Blog
            </Link>
            <svg
              className="w-3 h-3 text-white/40"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2.5}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9 5l7 7-7 7"
              />
            </svg>
            <span className="text-white/90 font-medium truncate max-w-[200px] sm:max-w-xs">
              Salem Guide
            </span>
          </nav>

          {/* Category Tag */}
          <span className="inline-block px-3 py-1 rounded-full text-white text-[10px] font-bold tracking-[0.2em] uppercase mb-4 bg-[#9b1c2e]">
            Restaurant Guide • Salem
          </span>

          {/* Title */}
          <h1 className="text-2xl sm:text-4xl lg:text-[40px] font-bold text-white leading-snug tracking-wide uppercase max-w-4xl mb-4">
            Best Restaurant in Salem - Barbequeen Restaurant
          </h1>

          {/* Meta Bar */}
          <div className="flex flex-wrap items-center gap-5 text-xs text-white/80 font-sans pt-2">
            <div className="flex items-center gap-2">
              <div className="w-7 h-7 rounded-full bg-[#9b1c2e] flex items-center justify-center text-white font-bold text-xs">
                B
              </div>
              <span className="font-semibold text-white">
                Barbequeen Editorial
              </span>
            </div>
            <span className="text-white/30">•</span>
            <div className="flex items-center gap-1.5 text-white/70">
              <svg
                className="w-3.5 h-3.5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <span>5 min read</span>
            </div>
          </div>
        </div>
      </section>

      {/* ── Author / Social Share Row ── */}
      <div className="max-w-6xl mx-auto px-4 lg:px-8">
        <div className="flex flex-wrap items-center justify-between gap-4 py-5 border-b border-gray-200">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-[#9b1c2e] flex items-center justify-center flex-shrink-0 text-white font-bold text-sm">
              B
            </div>
            <div>
              <p className="text-sm font-semibold text-gray-800">
                Barbequeen Editorial
              </p>
              <p className="text-xs text-gray-400">
                Serving Salem & Tamil Nadu Since 1999
              </p>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <span className="px-3 py-1 rounded-full border border-gray-200 text-xs font-semibold text-gray-600 uppercase tracking-wide bg-white">
              Salem City Guide
            </span>
            <span className="text-sm text-gray-500">8 Outlets in Salem</span>
          </div>

          <div className="flex items-center gap-3">
            <span className="text-sm text-gray-400 font-medium">Share:</span>
            <a
              href="https://instagram.com/barbequeenrestaurant"
              target="_blank"
              rel="noopener noreferrer"
              className="w-8 h-8 rounded-full border border-gray-200 flex items-center justify-center text-gray-500 hover:border-[#9b1c2e] hover:text-[#9b1c2e] transition-colors"
            >
              <svg
                className="w-3.5 h-3.5"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
              </svg>
            </a>
            <a
              href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(pageUrl)}&text=${encodeURIComponent(pageTitle)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="w-8 h-8 rounded-full border border-gray-200 flex items-center justify-center text-gray-500 hover:border-[#9b1c2e] hover:text-[#9b1c2e] transition-colors"
            >
              <svg
                className="w-3.5 h-3.5"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.253 5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
              </svg>
            </a>
            <a
              href={`https://facebook.com/sharer/sharer.php?u=${encodeURIComponent(pageUrl)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="w-8 h-8 rounded-full border border-gray-200 flex items-center justify-center text-gray-500 hover:border-[#9b1c2e] hover:text-[#9b1c2e] transition-colors"
            >
              <svg
                className="w-3.5 h-3.5"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
              </svg>
            </a>
          </div>
        </div>
      </div>

      {/* ── Main Content + Sidebar Layout ── */}
      <div className="max-w-6xl mx-auto px-4 lg:px-8 py-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          {/* ── Left Column: Article Body ── */}
          <main className="lg:col-span-8">
            {/* Excerpt */}
            <p className="text-[16px] text-gray-700 leading-[1.85] mb-8 italic border-l-4 border-[#9b1c2e] pl-4 bg-white p-4 rounded-r-lg shadow-sm">
              In a food-loving city like Salem, diners know the difference
              between an ordinary grill and one that is marinated, seasoned, and
              fired to perfection. Standing out in this vibrant food scene takes
              time-tested recipes, real charcoal-grill expertise, and unwavering
              consistency. Since 1999, Barbequeen Restaurant has done exactly
              that, earning its place as a go-to name for families and food
              lovers searching for the <strong>Best Restaurant in Salem</strong>
              .
            </p>

            {/* Section 1 */}
            <h2 className="text-2xl font-bold text-gray-900 leading-snug mt-8 mb-4 border-b border-gray-200 pb-2">
              The Barbequeen Experience in Salem
            </h2>
            <p className="text-[15px] text-gray-600 leading-[1.85] mb-4">
              The moment you step in, the aroma of charcoal-grilled chicken,
              warm tandoori spice, and slow-cooked Arabian mandi sets the stage
              for a memorable meal. Whether you are stopping by for a quick
              lunch or settling in with the whole family, our generous portions
              promise complete satisfaction and a reason to come back.
            </p>

            {/* Section 2 */}
            <h2 className="text-2xl font-bold text-gray-900 leading-snug mt-8 mb-4 border-b border-gray-200 pb-2">
              The Grill Expert, Perfected: Home of the Double Marinated Grill
              Chicken
            </h2>
            <p className="text-[15px] text-gray-600 leading-[1.85] mb-4">
              Our signature Double Marinated Grill Chicken undergoes a two-step
              marination process that infuses spice deep into the meat before
              hitting the charcoal grill. The result is a juicy interior, crisp
              smoky skin, and balanced heat in every bite. Along with fresh
              Chicken Shawarma, tender Pepper Chicken Tikka, and our sizzling
              BBQ Platter, there is no question why diners call us the best
              barbecue in Salem.
            </p>

            {/* Section 3 */}
            <h2 className="text-2xl font-bold text-gray-900 leading-snug mt-8 mb-4 border-b border-gray-200 pb-2">
              Wood-Fire Dum Biryani & Mandi Delicacies
            </h2>
            <p className="text-[15px] text-gray-600 leading-[1.85] mb-4">
              A meal here is never complete without biryani. We layer aged
              basmati with marinated chicken or slow-cooked mutton over a gentle
              dum so every grain absorbs the rich, aromatic spices. For groups
              that love sharing, our Family Bucket Biryani and Arabian Chicken
              Mandi, served on large platters with roasted nuts and raisins,
              bring everyone around the table.
            </p>

            {/* Section 4 */}
            <h2 className="text-2xl font-bold text-gray-900 leading-snug mt-8 mb-4 border-b border-gray-200 pb-2">
              A Complete Menu for the Whole Family
            </h2>
            <p className="text-[15px] text-gray-600 leading-[1.85] mb-3">
              Beyond grills and biryanis, our kitchen serves a broad variety of
              Indian curries, Chinese wok specials, seafood gravies, and
              tandoori breads:
            </p>
            <div className="space-y-2 mb-6">
              {[
                "Butter Chicken & Garlic Naan fresh from the tandoor",
                "Spicy Dragon Chicken & Schezwan Fried Rice",
                "Crab Lollipop & Prawn Masala for seafood lovers",
                "Paneer Butter Masala, Mushroom Tikka, and rich veg gravies",
              ].map((item, idx) => (
                <div key={idx} className="flex gap-3 items-start">
                  <span className="w-2 h-2 rounded-full bg-[#9b1c2e] mt-2 flex-shrink-0" />
                  <p className="text-[15px] text-gray-700 leading-[1.8] flex-1">
                    {item}
                  </p>
                </div>
              ))}
            </div>

            {/* Section 5: Outlets Directory */}
            <h2 className="text-2xl font-bold text-gray-900 leading-snug mt-10 mb-4 border-b border-gray-200 pb-2">
              Our 8 Outlets Across Salem
            </h2>
            <p className="text-[15px] text-gray-600 leading-[1.85] mb-6">
              With 8 locations across Salem, exceptional food is always within
              reach:
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
              {SALEM_OUTLETS.map((outlet) => (
                <div
                  key={outlet.id}
                  className="bg-white rounded-xl p-5 border border-gray-200 hover:border-[#9b1c2e]/40 hover:shadow-md transition-all duration-200 flex flex-col justify-between"
                >
                  <div>
                    <h3 className="text-base font-bold text-gray-900 mb-1.5">
                      {outlet.name}
                    </h3>
                    <p className="text-xs text-gray-500 leading-relaxed mb-3">
                      {outlet.address}
                    </p>
                  </div>
                  <div className="flex items-center justify-between pt-3 border-t border-gray-100 text-xs">
                    <a
                      href={`tel:${outlet.callNumber}`}
                      className="font-bold text-[#9b1c2e] hover:underline flex items-center gap-1.5"
                    >
                      <svg
                        className="w-3.5 h-3.5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                        />
                      </svg>
                      {outlet.phone}
                    </a>
                    <a
                      href={`https://google.com/maps/search/?api=1&query=${encodeURIComponent(outlet.mapQuery)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-gray-400 hover:text-[#9b1c2e] font-medium"
                    >
                      Get Directions →
                    </a>
                  </div>
                </div>
              ))}
            </div>

            {/* Section 6: Dine-In & Delivery */}
            <h2 className="text-2xl font-bold text-gray-900 leading-snug mt-8 mb-4 border-b border-gray-200 pb-2">
              Dine-In, Takeaway & Delivery
            </h2>
            <p className="text-[15px] text-gray-600 leading-[1.85] mb-4">
              All 8 outlets are open daily from{" "}
              <strong>11:00 AM to 11:00 PM</strong>, welcoming families,
              students, and professionals for dine-in and takeaway. Prefer
              dining at home? Order directly through our website or find us on
              Swiggy and Zomato for fast, hot doorstep delivery.
            </p>

            {/* Section 7: FAQs */}
            <h2 className="text-2xl font-bold text-gray-900 leading-snug mt-12 mb-6 border-b border-gray-200 pb-2">
              Frequently Asked Questions
            </h2>
            <div className="space-y-3 mb-10">
              {FAQS.map((faq, idx) => (
                <div
                  key={idx}
                  className="bg-white rounded-xl border border-gray-200 overflow-hidden transition-all duration-200"
                >
                  <button
                    onClick={() => toggleFaq(idx)}
                    className="w-full px-5 py-4 text-left flex items-center justify-between gap-4 font-semibold text-gray-800 text-sm hover:text-[#9b1c2e] transition-colors"
                  >
                    <span>{faq.q}</span>
                    <span className="text-[#9b1c2e] text-lg font-bold flex-shrink-0">
                      {openFaq === idx ? "−" : "+"}
                    </span>
                  </button>
                  {openFaq === idx && (
                    <div className="px-5 pb-4 text-xs sm:text-sm text-gray-600 leading-relaxed border-t border-gray-100 pt-3">
                      {faq.a}
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Tags / Bottom Share */}
            <div className="mt-10 pt-6 border-t border-gray-200 flex flex-wrap items-center justify-between gap-4">
              <div className="flex items-center gap-2 text-xs text-gray-500">
                <span className="font-semibold text-gray-700">Tags:</span>
                <span className="bg-gray-100 px-2.5 py-1 rounded-md">
                  Best Restaurant in Salem
                </span>
                <span className="bg-gray-100 px-2.5 py-1 rounded-md">
                  Salem Biryani
                </span>
                <span className="bg-gray-100 px-2.5 py-1 rounded-md">
                  Barbecue
                </span>
              </div>
              <a
                href={`https://wa.me/?text=${encodeURIComponent(pageTitle + " " + pageUrl)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-4 py-2 bg-[#25d366] text-white text-xs font-bold rounded-lg hover:opacity-90 transition-opacity"
              >
                Share on WhatsApp
              </a>
            </div>
          </main>

          {/* ── Right Column: Sidebar ── */}
          <aside className="lg:col-span-4 space-y-6">
            {/* Other Cities Widget */}
            <div className="bg-white rounded-2xl p-6 border border-gray-200 shadow-sm">
              <h3 className="text-base font-bold text-gray-900 mb-4 pb-2 border-b border-gray-100 flex items-center gap-2">
                <span className="w-2.5 h-2.5 rounded-full bg-[#9b1c2e]"></span>
                Other City Guides
              </h3>
              <div className="space-y-3">
                {OTHER_GUIDES.map((guide, idx) => (
                  <Link
                    key={idx}
                    to={guide.path}
                    className="group block p-3 rounded-xl bg-gray-50 hover:bg-[#9b1c2e]/5 border border-transparent hover:border-[#9b1c2e]/20 transition-all duration-200"
                  >
                    <span className="text-xs font-bold uppercase tracking-wider text-[#9b1c2e] block mb-0.5">
                      {guide.city}
                    </span>
                    <p className="text-sm font-semibold text-gray-800 group-hover:text-[#9b1c2e] transition-colors">
                      {guide.title} →
                    </p>
                  </Link>
                ))}
              </div>
            </div>

            {/* Quick Actions Widget */}
            <div className="bg-[#1a0a0d] text-white rounded-2xl p-6 shadow-md">
              <span className="text-[10px] font-bold tracking-[0.25em] text-[#c0424e] uppercase block mb-2">
                SINCE 1999
              </span>
              <h3 className="text-lg font-bold mb-3">Visit Barbequeen Salem</h3>
              <p className="text-xs text-gray-300 leading-relaxed mb-5">
                Craving our double marinated charcoal grill, wood-fire dum
                biryani, or Arabian mandi? Explore the full menu or visit your
                nearest Salem outlet.
              </p>
              <div className="space-y-2.5">
                <Link
                  to="/menu"
                  className="block w-full py-2.5 text-center bg-[#9b1c2e] hover:bg-[#801423] text-white text-xs font-bold rounded-xl uppercase tracking-wider transition-colors"
                >
                  Explore Full Menu
                </Link>
                <Link
                  to="/contact-us"
                  className="block w-full py-2.5 text-center bg-white/10 hover:bg-white/20 border border-white/20 text-white text-xs font-bold rounded-xl uppercase tracking-wider transition-colors"
                >
                  Contact & Outlets
                </Link>
              </div>
            </div>

            {/* Why Barbequeen Widget */}
            <div className="bg-white rounded-2xl p-6 border border-gray-200 shadow-sm">
              <h3 className="text-base font-bold text-gray-900 mb-4 pb-2 border-b border-gray-100">
                Why Diners Choose Us
              </h3>
              <ul className="space-y-3 text-xs text-gray-600">
                <li className="flex items-start gap-2.5">
                  <span className="text-[#9b1c2e] font-bold">✓</span>
                  <span>
                    <strong>Double Marinated:</strong> Signature spice blend
                    infused deep into the meat.
                  </span>
                </li>
                <li className="flex items-start gap-2.5">
                  <span className="text-[#9b1c2e] font-bold">✓</span>
                  <span>
                    <strong>Real Charcoal Fire:</strong> Traditional authentic
                    grilling technique.
                  </span>
                </li>
                <li className="flex items-start gap-2.5">
                  <span className="text-[#9b1c2e] font-bold">✓</span>
                  <span>
                    <strong>25+ Years Legacy:</strong> Serving families with
                    consistent taste since 1999.
                  </span>
                </li>
                <li className="flex items-start gap-2.5">
                  <span className="text-[#9b1c2e] font-bold">✓</span>
                  <span>
                    <strong>8 Convenient Outlets:</strong> Across key hubs in
                    Salem.
                  </span>
                </li>
              </ul>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
};

export default BestRestaurantInSalemPage;
